import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect, useRef } from 'react';

import useMfeInterface from '../../context/useMfeInterface';
import { startSpan } from '../../shared/datadog';
import MicroFallback from './MicroFallback';

const AppraisalUI = () => {
  const mfeInterface = useMfeInterface();

  const localManifest = {
    file: 'index.js',
    manifest: `http://localhost:5005/assets-manifest.json?v=${Date.now()}`
  };
  const appUrl = process.env.CARVANA_APP_PUBLIC_URL || '';
  const isLocal = appUrl.includes('localhost');

  const defaultMfe = isLocal
    ? localManifest
    : {
        file: 'index.js',
        manifest: `${
          process.env.CARVANA_APP_STATIC_PUBLIC_URL
        }/stc-appraisal-ui/modules/assets-manifest.json?v=${Date.now()}`
      };

  const loaded = useRef(false);
  const mfeLoadSpan = useRef(startSpan(`MFE:Appraisal`, 'Load'));

  useEffect(() => {
    MfeLoad({
      files: [
        [
          'AppraisalModule',
          [
            {
              component: 'default',
              browser: true,
              local: localManifest,
              default: defaultMfe
            }
          ]
        ]
      ]
    });

    const slowTimer = setTimeout(() => {
      if (!loaded.current) mfeLoadSpan.current.addEvent('SlowLoad');
    }, 8000);
    const reallySlowTimer = setTimeout(() => {
      if (!loaded.current) mfeLoadSpan.current.addEvent('ReallySlowLoad');
    }, 15000);

    return () => {
      clearTimeout(slowTimer);
      clearTimeout(reallySlowTimer);
    };
  }, []);

  return (
    <MfeReactComponent
      component="default"
      module="AppraisalModule"
      fallback={{ Component: <MicroFallback span={mfeLoadSpan.current} />, timeout: 30000 }}
    >
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {({ Component }: any) => {
        loaded.current = true;
        mfeLoadSpan.current.addEvent('Success');
        mfeLoadSpan.current.end();
        return <Component mfeInterface={mfeInterface} />;
      }}
    </MfeReactComponent>
  );
};

export default AppraisalUI;
